var React = require('react');

function Eye (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"eye"),React.createElement("path",{"fill":"currentColor","d":"M9.04 10.981c-1.915 1.305-3.612 3.225-5.108 5.785 3.822 4.27 7.828 6.345 12.068 6.345s8.247-2.075 12.068-6.345c-1.495-2.56-3.193-4.48-5.108-5.785a7.111 7.111 0 1 1-13.911-.047l-.008.047zM.204 16.16C3.975 9.024 9.29 5.333 16 5.333c6.713 0 12.028 3.691 15.794 10.825.13.241.206.527.206.831 0 .432-.154.829-.411 1.137l.002-.003c-4.684 5.646-9.902 8.544-15.591 8.544S5.093 23.769.409 18.123a1.766 1.766 0 0 1-.408-1.133c0-.303.076-.589.21-.839l-.005.009z","key":1})]);
}

Eye.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Eye;

Eye.default = Eye;
